import React from 'react';
import { XIcon, AlertTriangleIcon } from 'lucide-react';
interface WarningBannerProps {
  onClose: () => void;
  onAutoCalculate: () => void;
  onUpdateRadius: () => void;
}
export function WarningBanner({
  onClose,
  onAutoCalculate,
  onUpdateRadius
}: WarningBannerProps) {
  return <div className="bg-red-50 border-b border-red-200 p-4" data-id="element-339">
      <div className="flex items-start gap-3" data-id="element-340">
        <AlertTriangleIcon className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-341" />
        <div className="flex-1" data-id="element-342">
          <p className="text-sm text-red-800 font-medium mb-2" data-id="element-343">
            Total span length does not match target radius
          </p>
          <div className="flex flex-wrap gap-2" data-id="element-344">
            <button onClick={onAutoCalculate} className="px-3 py-1.5 bg-red-600 hover:bg-red-700 text-white text-xs font-medium rounded-md transition-colors" data-id="element-345">
              Auto-calculate spans
            </button>
            <button onClick={onUpdateRadius} className="px-3 py-1.5 bg-white hover:bg-red-50 text-red-800 text-xs font-medium rounded-md border border-red-300 transition-colors" data-id="element-346">
              Update radius
            </button>
          </div>
        </div>
        <button onClick={onClose} className="text-red-600 hover:text-red-800 transition-colors" data-id="element-347">
          <XIcon className="w-5 h-5" data-id="element-348" />
        </button>
      </div>
    </div>;
}